var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContextMenuBitmapLayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "context-menu-bitmap-layer_svg__a",
    x: 0,
    y: 0,
    width: 15,
    height: 13,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "context-menu-bitmap-layer_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#context-menu-bitmap-layer_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.5 10l3.797-3.797a1.002 1.002 0 011.406 0L9.5 10l1.79-1.79a1.008 1.008 0 011.418-.002L15.5 11v2.15H.5V10z",
    stroke: "currentColor",
    fillOpacity: 0.35,
    fill: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#context-menu-bitmap-layer_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    mask: "url(#context-menu-bitmap-layer_svg__b)",
    cx: 10,
    cy: 4,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12.436.5H2.564c-.75 0-1.029.06-1.305.208a1.324 1.324 0 00-.551.551C.56 1.535.5 1.814.5 2.564v7.872c0 .75.06 1.029.208 1.305.127.238.313.424.551.551.276.148.555.208 1.305.208h9.872c.75 0 1.029-.06 1.305-.208.238-.127.424-.313.551-.551.148-.276.208-.555.208-1.305V2.564c0-.75-.06-1.029-.208-1.305a1.324 1.324 0 00-.551-.551C13.465.56 13.186.5 12.436.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextMenuBitmapLayer);
export default __webpack_public_path__ + "static/media/context-menu-bitmap-layer.79286c0c.svg";
export { ForwardRef as ReactComponent };